<template>
  <div class="card-picker">
    <div class="card-box">
      <div
        class="card-item"
        v-for="(item, index) in selectData"
        :key="index"
        :class="{ active: item[valueField] === activeValue }"
        @click="select(item)"
      >
        <div class="text">
          {{ item[textField] }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { Swipe, SwipeItem, Grid, GridItem } from "vant";
import cloneDeep from "lodash/cloneDeep";

export default {
  name: "CardPicker",
  components: {
    // [Swipe.name]: Swipe,
  },
  props: {
    selectData: {
      type: Array,
      default: () => [],
    },
    textField: {
      type: String,
      default: "Text",
    },
    valueField: {
      type: String,
      default: "Id",
    },
    value: {
      type: [String, Number],
      default: "",
    },
  },
  model: {
    prop: "value",
    event: "update",
  },
  watch: {
    value() {
      this.copyData();
    },
  },
  data() {
    return {
      activeValue: "",
    };
  },
  created() {
    this.copyData();
  },
  methods: {
    update(value) {
      this.$emit("update", value);
    },
    copyData() {
      this.activeValue = cloneDeep(this.value);
    },
    select(item) {
      this.activeValue = item[this.valueField];
      this.update(this.activeValue);
    },
  },
};
</script>

<style lang="less" scoped>
.card-picker {
  overflow: hidden;
  overflow-x: auto;
  .card-box {
    white-space: nowrap;
    position: relative;
    top: -10px;
    border-bottom: 1px solid #f1f1f1;
    .card-item {
      padding: 0.4rem;
      color: #7d7e80;
      font-size: 0.25rem;
      text-align: center;
      display: inline-block;
      & + .card-item {
        border-left: 1px solid #f1f1f1;
      }
      &.active {
        background: #1989fa;
        color: #fff;
      }
    }
  }
}
</style>
